import type { AxiosInstance } from 'axios';
import type { SubscriptionBlockUseCases } from '@subscriptions/composition/types';
import { createSubscriptionBlockHttpClient } from '@subscriptions/infrastructure/api/SubscriptionBlockHttpClient';
import { createSubscriptionBlockApiMapper } from '@subscriptions/infrastructure/mappers/SubscriptionBlockApiMapper';
import { createSubscriptionBlockApiRepository } from '@subscriptions/infrastructure/repositories/SubscriptionBlockApiRepository';
import {
  createSubscriptionBlockUseCase,
  listSubscriptionBlocksUseCase,
  getSubscriptionBlockUseCase,
  updateBlockPaymentMethodUseCase,
  updateBlockInvoiceDataUseCase,
  updateBlockStoresUseCase,
  deleteSubscriptionBlockUseCase,
  fetchStoresForBlockUseCase,
  generateReferenceSubscriptionBlockUseCase,
  attachPaymentMethodUseCase,
} from '@subscriptions/application/use-cases';

/**
 * Assembles all subscription block use cases with their dependencies.
 *
 * @param httpClientSubscription - Axios instance bound to parrot-subscriptions-api
 */
export const createSubscriptionBlockUseCases = (httpClientSubscription: AxiosInstance): SubscriptionBlockUseCases => {
  const blockHttpClient = createSubscriptionBlockHttpClient({ httpClientSubscription });
  const mapper = createSubscriptionBlockApiMapper();
  const repository = createSubscriptionBlockApiRepository({
    httpClient: blockHttpClient,
    mapper,
  });

  return {
    createSubscriptionBlock: createSubscriptionBlockUseCase(repository),
    listSubscriptionBlocks: listSubscriptionBlocksUseCase(repository),
    getSubscriptionBlock: getSubscriptionBlockUseCase(repository),
    updateBlockPaymentMethod: updateBlockPaymentMethodUseCase(repository),
    updateBlockInvoiceData: updateBlockInvoiceDataUseCase(repository),
    updateBlockStores: updateBlockStoresUseCase(repository),
    deleteSubscriptionBlock: deleteSubscriptionBlockUseCase(repository),
    fetchStoresForBlock: fetchStoresForBlockUseCase(repository),
    generateReferenceSubscriptionBlock: generateReferenceSubscriptionBlockUseCase(repository),
    attachPaymentMethod: attachPaymentMethodUseCase(repository),
  };
};
